import { type PageIdentifier } from 'hb-react/shared/constants/pageIdentifiers';

// Mock for future implementation
export const usePageNamesQueries = (names: Array<PageIdentifier>) => {
  if (names?.length > 0) {
    // TODO: Implement the actual fetching of the page names.
  }

  return {
    isLoading: false,
    data: {},
  };
};
